(function () {

    // this component to show duplicate cases and actions
    var DuplicateCasesComponent = {
        bindings: {
            modalData: '<',
            hide: '&',
            everifyUtils: '<',
            onResubmit: '&'
        },
        templateUrl: '../modules/e-verify/components/duplicate-cases/duplicate-cases.html',
        controllerAs: 'duplicateCases',
        controller: ['$scope', '$q', function ($scope, $q) {

            var self = this;

            self.$onInit = function () {
                self.loading = true;
                self.brand = self.modalData.brand;
                self.duplicateCasesList = self.modalData.duplicate_cases;
                self.user = self.modalData.user;
                self.caseId = self.modalData.everify_case.id;
                self.late_reasons = self.modalData.late_reasons;
                self.late_reason_other_txt = self.modalData.late_reason_other_txt;
                self.alien_number = self.modalData.alien_number;
                self.phoneNumber = self.modalData.phoneNumber;

                self.STATUSES = EVerifyAPI.STATUSES;
                self.STATUSES_TEXT = EVerifyAPI.STATUSES_TEXT;
                self.SSA_DHS_TEXT = EVerifyAPI.SSA_DHS_TEXT;
                self.documentsTypeTitle = OnBoardingAPI.DOCUMENT_CODES_TITLES;
                self.citizenshipCodes = {
                    US_CITIZEN: 'U.S. Citizen',
                    NON_CITIZEN: 'Non U.S. Citizen',
                    PERMENANT: 'Lawful Permanent Resident',
                    ALIEN_AUTH: 'Alien Authorized to Work'
                };

                var promises = {};

                for (var i in self.duplicateCasesList) {
                    var caseInfo = self.duplicateCasesList[i];

                    if (self.duplicateCasesList[i].status !== self.STATUSES.CLOSED) {
                        self.isOpenStatusCase = true;
                    }

                    if (caseInfo.id) {
                        promises['case_details_' + caseInfo.id] = EVerifyAPI.getCaseDetails(self.brand.id, caseInfo.user_id, caseInfo.id);

                        if (caseInfo.status === EVerifyAPI.STATUSES.CLOSED && !promises['closure_reasons']) {
                            promises['closure_reasons'] = EVerifyAPI.getClosureReasonsList();
                        }
                    }
                }

                $q.all(promises)
                    .then(function (res) {
                        var extraDetailsPromises = {};

                        self.CLOSURE_REASON = res['closure_reasons'] || {};

                        for (var i in self.duplicateCasesList) {
                            var caseInfo = self.duplicateCasesList[i];
                            var caseDetails = res['case_details_' + caseInfo.id];

                            if (caseDetails) {
                                self.duplicateCasesList[i]['caseDetails'] = caseDetails;
                                self.duplicateCasesList[i]['innerDetails'] = caseDetails.external_details;
                                self.duplicateCasesList[i]['metaData'] = caseDetails.meta_data && caseDetails.meta_data['external_details'] || {};
                                self.duplicateCasesList[i]['harriDetails'] = caseDetails.meta_data && caseDetails.meta_data['harri_details'] || {};

                                if (caseDetails.vis_case) {
                                    self.duplicateCasesList[i]['innerDetails']['eligibility_statement'] = caseDetails.vis_case['eligibility_statement'];
                                    self.duplicateCasesList[i]['innerDetails']['referral_date'] = caseDetails.vis_case['referral_date'];
                                    self.duplicateCasesList[i]['innerDetails']['dhs_status'] = caseDetails.vis_case['dhs_status'];
                                    self.duplicateCasesList[i]['innerDetails']['ssa_status'] = caseDetails.vis_case['ssa_status'];
                                    self.duplicateCasesList[i]['innerDetails']['submitted_on'] = caseDetails.vis_case['submitted_on'];
                                }

                                var updatedCase = {
                                    document_id: caseDetails.document_id,
                                    id: caseDetails.id,
                                    job_id: caseDetails.job_id,
                                    status: caseDetails.status,
                                    sub_status: caseDetails.sub_status,
                                    user_id: caseDetails.user_id
                                };

                                angular.extend(caseInfo, updatedCase);

                                if (caseDetails.started_by && caseInfo.id) {
                                    extraDetailsPromises['user_main_details_' + caseInfo.id] = UserAPI.getUserBasicDetails(caseDetails.started_by);
                                }

                                if (caseInfo.user_id) {
                                    extraDetailsPromises['user_info_' + caseInfo.user_id] = UserAPI.getUserBasicDetails(caseInfo.user_id);
                                }
                            }
                        }

                        $q.all(extraDetailsPromises)
                            .then(function (result) {
                                for (var i in self.duplicateCasesList) {
                                    var caseInfo = self.duplicateCasesList[i];
                                    var mainUserDetails = result['user_main_details_' + caseInfo.id];
                                    var userInfo = result['user_info_' + caseInfo.user_id];

                                    if (mainUserDetails) {
                                        self.duplicateCasesList[i]['innerDetails'] = self.duplicateCasesList[i]['innerDetails'] || {};
                                        self.duplicateCasesList[i]['innerDetails']['SubmittingOfficialName'] = (
                                            mainUserDetails.first_name + " " + mainUserDetails.last_name
                                        );
                                    }

                                    if (userInfo) {
                                        self.duplicateCasesList[i]['user'] = userInfo;
                                    }
                                }

                                self.loading = false;
                            })
                            .catch(function (err) {
                                console.error(err);
                                self.everifyUtils.handleEVerifyErrorMessages(err, function () {
                                    self.loading = false;
                                    self.hide({statusCode: 'ERROR', data: err});
                                });
                            });
                    })
                    .catch(function (err) {
                        console.error(err);
                        self.everifyUtils.handleEVerifyErrorMessages(err, function () {
                            self.loading = false;
                            self.hide({statusCode: 'ERROR', data: err});
                        });
                    });
            };

            self.onSectionLoad = function () {
                self.formValidation = self.everifyUtils.getFormValidation($scope, 'duplicate-reasons');
                self.formValidation.onViewLoaded();
            };

            self.submitDuplicate = function () {
                if (self.formValidation.validator.validate()) {
                    self.actionStarting = true;

                    EVerifyAPI.startUserCase(
                        self.brand.id,
                        self.user.id,
                        self.caseId,
                        self.late_reasons,
                        self.late_reason_other_txt,
                        self.alien_number,
                        self.phoneNumber,
                        self.duplicateReason
                    ).then(function (data) {
                        self.hide({statusCode: 'SUCCESS', data: data});
                        self.actionStarting = false;
                        $scope.$digest();
                    }, function (err) {
                        self.everifyUtils.handleEVerifyErrorMessages(err, function () {
                            self.actionStarting =  false;
                            self.hide({statusCode: 'ERROR', data: err});
                        });
                    });
                }
            };
        }]
    };

    angular.module('harriApp.eVerify')
        .component('duplicateCases', DuplicateCasesComponent);
})();